import { FsContact } from "./fs-contact.model";

export class CachedFsContact {
    fsContact: FsContact;
    assessmentId: number;
    profileId: number;
    saveDate: Date;
}